import React, { Component } from 'react'
import { appInfo, retrieveAppInfo } from '../../actions'
import { Col, Row } from 'antd';
import { getIsPremiumUser } from '../../lib/fileUtils';
import { bookImage, podcastHrefUrl, podcastSlugUrl } from '../../lib/utils';
import AppCustomLink from './AppCustomLink';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class BookOfDay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // visible: false,
            appInfoLoc: {},
            errorObj: {}
        }
    }
    componentDidMount() {
        this.getAppInfVal();
    }

    getAppInfVal = () => {
        const appInf = retrieveAppInfo();
        if (Object.keys(appInf).length == 0) {
            setTimeout(() => {
                this.getAppInfVal();
            }, 500);
        } else {
            this.setState({ appInfoLoc: appInf });
        }
    }

    render() {
        const { appInfoLoc } = this.state;
        if (!appInfoLoc.bookOfDay) {
            return <div></div>
        }
        const bookOfDay = appInfoLoc.bookOfDay;
        return (
            <div className='main'>
                <AppCustomLink href={podcastHrefUrl(bookOfDay.collectionId)}
                    as={podcastSlugUrl(bookOfDay.collectionName, bookOfDay.collectionId)}>
                    <Row style={{ maxWidth: '400px', margin: 'auto' }}>
                        <Col span={12} style={{ margin: 'auto' }}>
                            <h2>{getIsPremiumUser()
                                ? 'Book Of The \nDay'
                                : 'Free Daily Summary'}</h2>
                            <h3>Try It&nbsp; <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                            </h3>
                        </Col>
                        <Col span={12}>
                            <img style={{ maxWidth: '140px' }} src={bookImage(bookOfDay)} alt={`${bookOfDay.collectionName || ''} book`} />
                        </Col>
                    </Row>
                </AppCustomLink>
                <style jsx>
                    {`
                    .main {
                        background: #${bookOfDay.bgColor};
                        padding: 2em 2em;
                        border-radius: 24px;
                        margin-bottom: 4em;
                        cursor: pointer;
                        box-shadow: 0 20px 40px 0 rgba(0, 11, 40, .04);
                    }
                        h2 {
                            font-size: 2em;
                        }
                    `}
                </style>
            </div>
        )
    }
}
